module.exports = __webpack_public_path__ + "static/img/16a.a38a82e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/16a.jpg
// module id = wNZC
// module chunks = 0